<style lang="scss" scoped>
.notifications {
    .view-all {
        border-top: 1px solid var(--border-color);
    }
    .nav-item {
        cursor: pointer;
        line-height: 24px;
        &:hover {
            background: var(--white-hover);
        }
    }
    .read-at {
        background: var(--gold);
        border-radius: 50%;
        width: 8px;
        height: 8px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
    }
}
</style>

<template>
    <div class="notifications py-32">
        <p class="fw-b mb-16 mt-16 px-md-24 d-flex">
            <span class="h4 fw-b my-auto">{{ $t('navbar.notifications') }}</span>
            <a @click="readAllNotifications" class="text-right text-gold small px-16 c-pointer ml-auto my-auto">{{ $t('notifications.mark_all_as_read') }}</a>
        </p>
        <template v-if="notifications.length > 0">
            <div class="nav-item" v-for="notification in notifications" :key="notification.id">
                <a @click="goToNotificationRoute(notification)" class="pr-md-16 py-8 border-bottom d-block position-relative mx-md-24 my-auto">
                    <p class="text-dark">{{ $t(`navbar.${notification.message}`) }}</p>
                    <p class="text-gray small col-md-8 px-0">{{ $t(`navbar.${notification.message}_desc`) }}</p>
                    <p class="small text-gray">{{ [ notification.created_at ] | moment("from", "now") }}</p>
                    <span v-if="notification.read_at === null" class="read-at"></span>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
export default {

    methods: {
        goToNotificationRoute(n) {
            let notification_status = [{ id: n.id, read: true }]
            this.$store.dispatch('user/updateNotifications', { user_id: this.currentUser.user.id, data: notification_status }).then(() => {
                let route = ''
                if (n.resource_type === 'tip') route = { name: 'tip-detail', params: { id: n.resource_id } }
                if (n.resource_type === 'diary_entry') route = { name: 'schedule-details', query: { date: n.metadata.date, week: n.resource_id } }
                if (n.resource_type === 'sleep_schedule') route = { name: 'user-habits' }
                if (route !== '') this.$router.push(route)
            })
        },
        readAllNotifications() {
            let notification_status = this.notifications.map((n) => { return { id: n.id, read: true } })
            this.$store.dispatch('user/updateNotifications', { user_id: this.currentUser.user.id, data: notification_status })
        }
    },

    computed: {
        notifications() {
            return this.$store.getters['user/notifications']
        },
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
